export default {
    computed: {
        distanceSettings() {
            return {
                separator: ',',
            }
        }
    },
    methods: {
        formatDistance(
            value,
            separator = this.distanceSettings.separator
        ) {
            const distance = value.toString().replace('.', separator)

            return distance || '-'
        },
        unformatDistance(value, separator = this.distanceSettings.separator) {
            if (!value) {
                return false
            }

            return parseFloat(value.replace(separator, '.'))
        },
    }
}